import { useMemo } from 'react'

export const DATATYPE_COURSE = 'COURSE'
export const DATATYPE_CATEGORY = 'CATEGORY'
export const DATATYPE_STREAMING_VIDEO = 'STREAMING_VIDEO'
export const DATATYPE_COURSE_TEMPLATE = 'COURSE_TEMPLATE'
export const DATATYPE_COURSE_TEMPLATE_CATEGORY = 'COURSE_TEMPLATE_CATEGORY'
export const DATATYPE_NODE_LIBRARY = 'NODE_LIBRARY'
export const DATATYPE_NODE_LIBRARY_CATEGORY = 'NODE_LIBRARY_CATEGORY'

const isDataType = (node, type) => {
  try {
    let metadata = getMetadata(node)

    if (!metadata.datatype) {
      return false
    }

    return metadata.datatype === type.toLowerCase()
  } catch (e) {
    return false
  }
}

export const isDatatypeCourse = node => isDataType(node, DATATYPE_COURSE)
export const isDatatypeCategory = node => isDataType(node, DATATYPE_CATEGORY)
export const isDatatypeStreamingVideo = node => isDataType(node, DATATYPE_STREAMING_VIDEO)
export const isDatatypeCourseTemplate = node => isDataType(node, DATATYPE_COURSE_TEMPLATE)
export const isDatatypeNodeTemplateCategory = node => isDataType(node, DATATYPE_COURSE_TEMPLATE_CATEGORY)
export const isDatatypeNodeLibrary = node => isDataType(node, DATATYPE_NODE_LIBRARY)
export const isDatatypeNodeLibraryCategory = node => isDataType(node, DATATYPE_NODE_LIBRARY_CATEGORY)

export const getDatatype = node => {
  if (!node.metadata) {
    return ''
  }

  try {
    return node.metadata.DataType.toLowerCase()
  } catch (e) {
    return ''
  }
}

export const getMetadata = node => {
  if (!node.metadata) {
    return {}
  }

  if (!node._metadata) {
    let lower = node.metadata.toLowerCase()
    node._metadata = JSON.parse(lower)
  }

  return node._metadata
}

export const useIsHD = node => {
  return useMemo(
    () => {
      if (!node.metadata) {
        return false
      }

      let lower = node.metadata.toLowerCase()
      let metadata = JSON.parse(lower)

      const renderPipelineName = metadata['renderpipelinename']
      return renderPipelineName === 'urp' || renderPipelineName === 'hdrp'
    },
    [node]
  )
}
